import { useState } from "react";
import { Database, PlugZap, Copy } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, fmtDate } from "../lib/api";
import { Button } from "./ui/button";

export function DatabaseMove() {
  const [check, setCheck] = useState(null);
  const [result, setResult] = useState(null);
  const [busy, setBusy] = useState("");
  const run = async (kind) => {
    if (kind === "copy" && !window.confirm("Copy all BOS HQ data into the Atlas database in Sydney now? Please make sure nobody is using the app for the next few minutes.")) return;
    setBusy(kind);
    try {
      if (kind === "check") setCheck((await api.get("/agency/database-move/check")).data);
      else { const { data } = await api.post("/agency/database-move/copy"); setResult(data); toast[data.ok ? "success" : "error"](data.ok ? "All data copied and verified" : "Copy finished with mismatches"); }
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  return (
    <div className="rounded-md border bg-card/60 p-5 space-y-4 max-w-2xl" data-testid="database-move">
      <div className="flex items-center gap-2 text-[#C2A462] font-semibold"><Database className="h-4 w-4" />Move database to MongoDB Atlas (Sydney)</div>
      <p className="text-sm text-muted-foreground">Owner only. Step 1 checks the live app can reach Atlas. Step 2 copies every record across and confirms the counts match. Nothing is deleted from the current database.</p>
      <div className="flex gap-2">
        <Button variant="outline" onClick={() => run("check")} disabled={!!busy} data-testid="db-move-check-btn"><PlugZap className="h-4 w-4 mr-1" />{busy === "check" ? "Checking…" : "1. Check Atlas connection"}</Button>
        <Button onClick={() => run("copy")} disabled={!!busy || !check || check.target_records > 0} data-testid="db-move-copy-btn"><Copy className="h-4 w-4 mr-1" />{busy === "copy" ? "Copying…" : "2. Copy data to Atlas"}</Button>
      </div>
      {check && <div className="text-sm" data-testid="db-move-check-result">Connected to Atlas ✓ · database <b>{check.database}</b> · current records {check.source_records} · already in Atlas {check.target_records}{check.target_records > 0 && " (copy disabled: Atlas is not empty)"}</div>}
      {result && (
        <div className={`text-sm ${result.ok ? "text-emerald-400" : "text-red-400"}`} data-testid="db-move-copy-result">
          {result.ok ? "Verified" : "Mismatch"}: {result.records} records in {result.collections} collections copied · {fmtDate(result.at)}
        </div>
      )}
    </div>
  );
}
